import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ConfirmModal } from 'corso-admin-ui';
import api from '~/api';
import { useClaim } from '~/features/claimReview/ClaimReviewProvider';
import { useStoreId } from '~/providers/StoreUserProvider';

export default function CancelClaim({
  show,
  onClose,
  claimId,
}: {
  claimId: number;
  show: boolean;
  onClose: () => void;
}) {
  const storeId = useStoreId();

  const queryClient = useQueryClient();
  const claim = useClaim();

  const { mutate: cancelClaim, isPending } = useMutation({
    mutationKey: [claimId],
    mutationFn: () => api.store(storeId).claim(`${claimId}`).cancel(),
    onSuccess: () =>
      Promise.all([
        claim.refetch(),
        queryClient.invalidateQueries({
          queryKey: ['claims'],
        }),
      ]),
  });

  return (
    <ConfirmModal
      variant="caution"
      title="Permanently Cancel Claim"
      prompt="Canceled claims cannot be reopened and nothing will be issued to the customer. A customer can still create a new claim against this order."
      confirmText="Cancel Claim"
      cancelText="Cancel"
      show={show}
      loading={isPending}
      onConfirm={() => {
        cancelClaim();
        onClose();
      }}
      onCancel={onClose}
    />
  );
}
